<template>
  <f7-card-header
    :style="
                `background-image:url(`+url+`)`
              "
  ><span v-on:click="()=> onHandle()" class="background-place-image"></span></f7-card-header>
</template>
<script>
export default {
  props: {
    url: {
      required: false,
      type: String
    },
    onHandle: {
      required: false,
      type: Function,
      default() {
        return () => this.onHandleDefault();
      }
    }
  },
  methods: {
    onHandleDefault() {
      return null;
    }
  }
};
</script>

